import _typeof from "@babel/runtime/helpers/typeof";
export var isValidAddress = function isValidAddress(address) {
  return _typeof(address) === 'object' && address !== null && 'value' in address && typeof address.value === 'string' && 'house_fias_id' in address && typeof address.house_fias_id === 'string';
};